<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les textes" />
            <LesTextes />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesTextes from './LesTextes.vue';

export default {
    name: 'PelerinagePage',
    components: {
        NavBar,
        PageTitle,
        LesTextes,
        FooterComp,
    }
}
</script>